import {TipoDocumento} from "@/utils/constants/TipoDocumento";
import {limpaDocumento, validateTipoDocumento} from "@/utils/validators/Documento";

export function formataDocumento (str) {
    str = limpaDocumento(str);
    var tipoDocumento = validateTipoDocumento(str);
    switch (tipoDocumento) {
        case TipoDocumento.CPF:
            return str.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        case TipoDocumento.CNPJ:
            return str.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        case TipoDocumento.INVALID:
        default:
            return str;
    }
}

export function formataCEP(str) {
    return str.replace(/\D/g, "").replace(/^(\d{5})(\d)/, "$1-$2");
}

export function formataEndereco(objEndereco) {
    return (objEndereco.logradouro + ", " + objEndereco.numero + (objEndereco.complemento ? " - " + objEndereco.complemento : "")).substr(0, 45);
}


export function formataTelefone(str) {
    str = str.replace(/\D/g, "").replace(/^(\d\d)(\d)/g, "($1) $2");
    if(str.length < 14) str = str.replace(/(\d{4})(\d)/, "$1-$2");
    else str = str.replace(/(\d{5})(\d)/, "$1-$2");
    return str;
}

export function formataMoeda(str) {
    var valor = str.replace(/\D/g, "");
    if(valor != "")
        return new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}).format(valor / 100);
    else return "R$ 0,00";
}


